import { useEffect, useRef } from 'react'
import { Session } from '@ally/federated-types'

class DeferredPromise<D> {
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }

  public promise: Promise<D>

  public resolve!: (d: D) => void

  public reject!: (e: Error) => void
}

/**
 * Given a session object this function will return a pending promise
 * when the user is authenticated but awaiting legacy session data. The
 * pending promise will be resolved once it has legacy session data.
 */
export const useAwaitLegacyAuth = (session: Session): Promise<Session> => {
  const { current: deferred } = useRef(new DeferredPromise<Session>())

  useEffect(() => {
    if (session.status === 'Authenticated' && session.mayBeHasLegacySession) {
      deferred.resolve(session)
    }
  }, [session])

  if (session.status !== 'Authenticated' || session.mayBeHasLegacySession)
    return Promise.resolve(session)
  return deferred.promise
}
